export default __webpack_public_path__ + "static/media/grimcorruption2.5b3955e8.png";